import ru from './ru.json'
import en from './en.json'
import az from './az.json'
import { useUserStorage } from '@/modules/f8/hooks';

const localizations = {
  "ru-RU" : ru,
  "en-EN" : en,
  "az-AZ" : az
}


const userStorage = useUserStorage();
const locale = userStorage.ref('cfgLang', 'en-EN');

const localize = (code, format = null) => {

  const res = localizations[locale.value][code]
  if (!res) {
    console.warn(`Localization for code '${code}' not found in locale '${locale.value}'`)
    return localizations['en-EN'][code] || code
  }

  if (!format) {
    return res
  }
  
  switch (format) {
    case 'uppercase':
      return res.toUpperCase()
    case 'lowercase':
      return res.toLowerCase()
    case 'capitalize':
      return res.charAt(0).toUpperCase() + res.slice(1)
    default:
      console.warn(`Unknown format '${format}' for localization code '${code}'`)
      return res
  }
}

export { localize }